import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zuo",
  "use": "icon-zuo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zuo\"><defs><style></style></defs><path d=\"M796.477 950.898c16.76 16.704 16.76 43.833 0 60.538-16.676 16.752-43.81 16.752-60.49 0l-509.45-466.799c-8.9-8.95-12.714-20.789-12.134-32.452-.58-11.67 3.233-23.532 12.134-32.458l509.45-466.8c16.681-16.751 43.815-16.751 60.491 0 16.76 16.722 16.76 43.833 0 60.538l-478.66 438.719 478.659 438.714zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol